module.exports = __webpack_public_path__ + "img/1_3_mobile.45acd350.gif";